import React, { Component } from 'react'
import Title from '../components/title'
import Image from '../components/image'
import Contact from '../components/contact'
import me from '../media/me.png'
import { BELIZ, SILVER } from '../utils/colors'


class About extends Component {

    render() {
        return (

            <div className='container'>

                <Title />

                <div className='container' style={{padding: '2em', border: `solid 8px ${BELIZ}`}}>
                    <div className='level columns'>
                        <div className='column is-one-third has-text-centered'>
                            <Image source={me} height='400px'/>
                        </div>
                        <div className='column is-two-thirds' style={{color: `${SILVER}`}}>
                            <div>
                                <p>{`I enjoy problem solving, writing clean code, and learning as much as possible. I've grown to enjoy database design and development, writing complex queries for information retrieval and data manipulation. I have a solid background in web applications, backend database and custom APIs, as well as iOS/Android mobile development.`}</p>
                            </div>
                            <hr style={{border: `solid 2px ${BELIZ}`}}/>
                            <Contact />
                        </div>
                    </div>
                </div>

            </div>

        )
    }

}


export default About



// WEBPACK FOOTER //
// ./src/screens/about.js